import * as utility from "../lib/AuthorUtility";
import UniqueItem from "./UniqueItem";
import * as catalogUtility from "../lib/CatalogLinkUtilities";
import * as linkUtility from "lib/LinksUtilities";
import * as UrlUtilities from '../lib/UrlUtilities';

class SimilarTitle extends UniqueItem {
	/**
	 * Create a new instance of a similar title
	 * @param  {object} similarTitleJson A title json object from novelist select
	 */
	constructor(SimilarTitleJson) {
		super(SimilarTitleJson);

		this.title = SimilarTitleJson.main_title;
		this.author = utility.formatAuthorName(SimilarTitleJson.author);
		this.bookJacket = UrlUtilities.useLocalProtocol(SimilarTitleJson.bookjacket_url);
		this.reason = SimilarTitleJson.reason;
		this.catalogLink = catalogUtility.getTitleCatalogLink(SimilarTitleJson.links);
		this.lexile = SimilarTitleJson.lexile;
		this.linkToNovelist = linkUtility.getLinkToNoveListFromLinks(SimilarTitleJson.links);
		this.description = SimilarTitleJson.description;
		this.isHeld = SimilarTitleJson.is_held_locally;
	}
}

export default SimilarTitle;



// WEBPACK FOOTER //
// ./src/models/SimilarTitle.js